
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObcToggleButtonOption as ObcToggleButtonOptionElement} from '@oicl/openbridge-webcomponents/dist/components/toggle-button-option/toggle-button-option.js';
 
 
 

 
 export const ObcToggleButtonOption = createComponent({
   react: React,
   tagName: 'obc-toggle-button-option',
   elementClass: ObcToggleButtonOptionElement,
   events: {
     
   }
  });
 
 